/**
 * Доступ по подписке: модем привязывается кодом активации с устройства,
 * подписка продлевается оплатой. Из консоли модем не добавить — вместо
 * привязки там приветствие со ссылками на сборку и покупку.
 */

import { RequireAuth } from '../../AuthContext';
import { AccessModule } from '../AccessModule';
import AdminModemSubscription from './AdminModemSubscription';
import AdminSubscriptions from './AdminSubscriptions';
import AstraWelcome from './AstraWelcome';
import BuySetLink from './BuySetLink';
import ModemSubscription from './ModemSubscription';
import SubscriptionNotification from './SubscriptionNotification';
import UnbindNotice from './UnbindNotice';
import UserSubscription from './UserSubscription';

const subscriptionAccess: AccessModule = {
    routes: [
        { path: '/subscriptions', element: <RequireAuth><UserSubscription /></RequireAuth> },
        { path: '/adminSubscriptions', element: <RequireAuth><AdminSubscriptions /></RequireAuth> }
    ],
    adminLinks: [
        { to: '/adminSubscriptions', labelKey: 'admin_subscriptions', access: 'admin' }
    ],
    userLinks: [
        { to: '/subscriptions', labelKey: 'subscriptions_short', access: 'public' }
    ],
    LoginLinks: BuySetLink,
    ConsoleNotice: SubscriptionNotification,
    ConsoleEmptyState: ({ droneCount }) => <AstraWelcome droneCount={droneCount} />,
    AddDroneCard: null,
    ModemSettingsSection: ModemSubscription,
    UnbindNotice: UnbindNotice,
    AdminModemSection: AdminModemSubscription,
    showsModemIntegrations: false
};

export default subscriptionAccess;
